<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem to="/system/adminlist"> <Icon type="icon iconfont icon-qiye" /> 企业管理 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="md-build" /> 修改企业 </BreadcrumbItem>
        </Breadcrumb>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <div class="titlable"><span>修改企业基本信息</span></div>

        <div class="cominfo">
          <div>
            {{ street }}
          </div>
          <div style="margin-top: 10px" v-if="street == '在线公司'">
            是否接收信息
            <RadioGroup v-model="types" type="button" @on-change="typechange">
              <Radio label="是" />
              <Radio label="否" />
            </RadioGroup>

            <div v-if="types == '是'">
              <Input v-model="sendtime" class="inptext" size="large" placeholder="请设置报警短信发送间隔时间">
                <span slot="append">分</span>
              </Input>
              <Input v-model="sendPhones" class="inptext" size="large" placeholder="报警手机号。多个号码用,分割" />
            </div>
          </div>
          <div>
            <Input class="inptext" size="large" placeholder="登录用户名" v-model="account" disabled />
            <Button type="info" @click="editAccountModal = true" style="margin-top: 0.625rem; margin-left: 1.25rem"
              >修改用户名</Button
            >
            <Modal v-model="editAccountModal" title="修改用户名" @on-ok="editAccountOK()">
              <div>现公司账号：{{ account }}</div>
              <Input class="inptext" size="large" placeholder="新用户名" v-model="newAccount" />
            </Modal>
          </div>
          <Input v-model="companyname" class="inptext" size="large" placeholder="请输入企业名称" />
          <!-- <Cascaders :areaids = "areaid"></Cascaders> -->
          <Cascader v-model="areaid" :data="areadata" placeholder="请选择省市区" class="inptext" change-on-select />
          <Input v-model="jtdz" class="inptext" size="large" placeholder="请输入具体地址" />
          <Input v-model="fr" class="inptext" size="large" placeholder="请输入企业法人" />
          <Input v-model.trim="phone" class="inptext" size="large" placeholder="请输入企业联系方(手机号码)" />

          <Input v-model="hy" class="inptext" size="large" placeholder="请输入企业所属行业" />
          <div>
            <Input v-model="xy" class="inptext" size="large" placeholder="经度-纬度选择" />
            <Button type="primary" style="margin-top: 0.625rem; margin-left: 1.25rem" @click="getxy">拾取坐标</Button>
          </div>

          <Input
            v-model="Info"
            class="inpuarea"
            :autosize="{ minRows: 3, maxRows: 7 }"
            type="textarea"
            placeholder="请输入简介信息"
          />
        </div>
        <i-switch v-model="switch1" size="large" style="margin-top: 1.25rem">
          <span slot="open">启用</span>
          <span slot="close">停用</span>
        </i-switch>
        <div class="btnbox">
          <Button @click="backmast">取消</Button>
          <Button type="info" @click="addcompany">提交</Button>
        </div>
      </Card>
    </X-Layout>
  </div>
</template>

<script>
import Cascaders from '../../../components/Cascader.vue';
export default {
  components: {
    Cascaders,
  },
  data() {
    return {
      switch1: false,
      companyid: '',
      fruit: [],
      account: '', //公司账号
      newAccount: '', //新公司账号
      companyname: '',
      jtdz: '',
      fr: '',
      phone: '',
      hy: '',
      xy: '',
      Info: '',
      street: '',
      areaid: [],
      areadata: [],
      arealistid: '',
      arealist: false,
      types: '',
      type: '',
      sendtime: '', //报警短信间隔时间
      sendPhones: '', //报警手机号码 多个
      editAccountModal: false, //编辑用户名的窗口
    };
  },
  created() {
    const id = this.$route;
  },
  mounted() {
    const id = this.$route.params.comid;
    this.arealistid = id;

    this.getsheng(id);
    this.companyInfoId(this.arealistid); //得到公司信息
  },
  methods: {
    //是否接收信息事件
    typechange() {
      if (this.types == '否') {
        this.sendtime = '';
        this.sendPhones = '';
      }
    },
    companyInfoId(id) {
      const that = this;
      const api = this.ApiUrl + 'company/findById';
      const data = {
        company_id: id,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            const list = res.data.extend.company;

            that.account = res.data.extend.account; //公司账号
            that.companyid = list.company_id; //公司id
            that.companyname = list.company_name;
            that.Cascader = '';
            that.jtdz = list.address;
            that.fr = list.legalPerson;
            that.hy = list.industry;
            that.phone = list.phone;
            that.xy = list.xy;
            that.Info = list.information;
            that.fruit = (list.show || '').split('|');

            if (list.status == 0) {
              that.switch1 = true;
            } else if (list.status == 1) {
              that.switch1 = false;
            }
            this.type = list.type;
            if (list.type == 0) {
              that.street = '工况公司';
            } else if (list.type == 1) {
              that.street = '油烟公司';
            } else {
              that.street = '在线公司';
            }
            that.types = list.send_status == 0 ? '是' : '否';
            that.getquyu(list.area_id);

            if (list.send_interval) {
              //填充短信间隔
              this.sendtime = list.send_interval;
            }
            if (list.sms_phone) {
              //填充手机号
              this.sendPhones = list.sms_phone;
            }
          } else {
            this.$Message.warning(res.data.extend.message);
          }
        },
        res => {},
      );
    },
    getquyu: function (id) {
      const that = this;
      const api = this.ApiUrl + 'area/findProvinceCityArea';
      const data = {
        area_id: id,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            const list = res.data.extend;

            that.areaid[0] = list.province;
            that.areaid[1] = list.city;
            that.areaid[2] = list.area;
          }
        },
        res => {},
      );
    },

    getsheng(id) {
      const that = this;
      const api = this.ApiUrl + 'area/findAllArea';
      const data = {
        area_id: 1,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            const list = res.data.extend.area;
            for (var i = 0; i < list.length; i++) {
              if (!list[i].children) {
                list[i].children = list[i].list2;
              }
            }
            that.areadata = list;
          }
        },
        res => {},
      );
    },
    changval(e) {},
    addcompany() {
      const that = this;

      if (that.companyname == '' || that.companyname == null) {
        this.$Message.warning('请输入公司名');
        return;
      }
      if (that.xy == '' || that.xy == null) {
        this.$Message.warning('请输入经纬度');
        return;
      }
      // if (that.Info == "" || that.Info == null) {
      //   this.$Message.warning("请输入公司信息")
      //   return
      // }
      // if (that.hy == "" || that.hy == null) {
      //   this.$Message.warning("请输入公司行业")
      //   return
      // }
      // if (that.fr == "" || that.fr == null) {
      //   this.$Message.warning("请输入公司法人")
      //   return
      // }
      // if (that.phone == "" || that.phone == null) {
      //   this.$Message.warning("请输入企业联系方式")
      //   return
      // }
      if (that.areaid == '' || that.areaid == null) {
        this.$Message.warning('请选择地址');
        return;
      }
      if (that.areaid.length < 3) {
        this.$Message.warning('请选择地址');
        return;
      }
      if (that.jtdz == '' || that.jtdz == null) {
        this.$Message.warning('请填写具体地址');
        return;
      }
      if (that.fruit == []) {
        that.fruit = '';
      } else {
        let show = '';
        for (var i = 0; i < that.fruit.length; i++) {
          if (i < that.fruit.length - 1) {
            show += that.fruit[i] + '|';
          } else {
            show += that.fruit[i];
          }
        }

        that.fruit = show;
      }
      let status;
      if (that.switch1 == true) {
        status = 0;
      } else if (that.switch1 == false) {
        status = 1;
      }
      let tyStatus;
      if (this.type == 2) {
        tyStatus = that.types == '是' ? 0 : 1;

        if (that.types == '是') {
          if (!this.sendtime) {
            this.$Message.error('请输入报警短信发送间隔时间');
            return;
          }
          if (!this.sendPhones) {
            this.$Message.error('请输入报警号码');
            return;
          }
        }
      } else {
        tyStatus = 1;
      }
      const api = this.ApiUrl + 'company/updateCompany';
      const data = {
        send_status: tyStatus,
        company_name: that.companyname,
        area_id: that.areaid[2],
        address: that.jtdz,
        phone: that.phone,
        legalPerson: that.fr,
        industry: that.hy,
        xy: that.xy,
        information: that.Info,
        show: that.fruit,
        company_id: that.arealistid,
        status: status,
        send_interval: this.sendtime,
        sms_phone: this.sendPhones,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            this.$Message.success('修改成功');
            that.backmast();
          } else {
            this.$Message.warning(res.data.extend.message);
          }
        },
        res => {},
      );
    },
    //修改用户名接口请求
    editAccountOK() {
      const api = this.ApiUrl + 'company/updateCompanyAccount';
      const data = {
        company_id: this.companyid,
        account: this.newAccount,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            this.$Message.success(res.data.extend.message);
            this.account = this.newAccount; //成功后 把数据更新一下
          } else {
            this.$Message.warning(res.data.extend.message);
          }
          this.newAccount = ''; //清空
        },
        res => {},
      );
    },
    getxy() {
      window.open('http://api.map.baidu.com/lbsapi/getpoint/index.html');
    },
    // 返回主页
    backmast() {
      this.$router.push({
        path: '/system/adminlist',
      });
    },
  },
};
</script>

<style scoped>
.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.picbox {
  height: 12.5rem;
  width: 12.5rem;
  border: 1px solid #ccc;
}
.ivu-input {
  width: 25rem;
}
.titlable {
  height: 24px;
  border-left: 0.125rem solid aquamarine;
  padding-left: 20px;
  line-height: 24px;
  margin-bottom: 20px;
}

.cominfo {
  display: flex;
  flex-direction: column;
}

.inptext {
  margin-top: 0.625rem;
  width: 25rem;
}

.inpuarea {
  margin-top: 0.625rem;
  width: 25rem;
}

.btnbox {
  margin-top: 1.25rem;
  width: 25rem;
  display: flex;
}
.btnbox > button {
  margin-right: 200px;
}
</style>
